/**
 * Copyright 2026 ForgeRock AS. All Rights Reserved
 *
 * Use of this code requires a commercial software license with ForgeRock AS
 * or with one of its affiliates. All use shall be exclusively subject
 * to such license between the licensee and ForgeRock AS.
 */

export default {
  sideMenu: [
    {
      routeTo: { name: 'Dashboard' },
      displayName: 'sideMenu.dashboard',
      icon: 'dashboard',
    },
    {
      displayName: 'sideMenu.identities',
      icon: 'people',
      subItems: [
        {
          displayName: 'sideMenu.managed',
          routeTo: {
            name: 'ManagedIdentities',
          },
        },
        {
          routeTo: { name: 'Connect' },
          displayName: 'sideMenu.connect',
        },
        {
          routeTo: { name: 'BulkImport' },
          displayName: 'sideMenu.bulkImport',
        },
        {
          routeTo: { name: 'ConfigureManaged' },
          displayName: 'sideMenu.configureManaged',
        },
      ],
    },
    { isDivider: true },
    {
      routeTo: { name: 'Provisioners' },
      displayName: 'sideMenu.provisioners',
      icon: 'settings_ethernet',
    },
    {
      routeTo: { name: 'Jobs' },
      displayName: 'sideMenu.jobs',
      icon: 'event_available',
    },
    {
      routeTo: { name: 'Events' },
      displayName: 'events.title',
      icon: 'login',
    },
    {
      displayName: 'sideMenu.customEndpoints',
      icon: 'code',
      routeTo: { name: 'CustomEndpoints' },
    },
    { isDivider: true },
    {
      displayName: 'sideMenu.email',
      icon: 'mail',
      subItems: [
        {
          routeTo: { name: 'EmailTemplates' },
          displayName: 'sideMenu.templates',
        },
        {
          routeTo: { name: 'EmailProvider' },
          displayName: 'sideMenu.provider',
        },
      ],
    },
  ],
};
